import React, {useEffect, useState, useRef} from 'react'
import {useParams} from 'react-router-dom'
import {districts} from '../Options'
import Sidebar from '../Sidebar'
// import env from 'react-dotenv'
 
export default function EditSowing() {
    //all the states
    const [seed_varieties, setSV] = useState()
    const [seed_name, setSN] = useState()
    const [district, setDistrict] = useState()
    const [district_id, setDistrictID] = useState()
    const [specification, setSpec] = useState()
    const [germination, setGerm] = useState()
    const [year, setYear] = useState()

    //all the refs
    const snRef = useRef(null)
    const svRef = useRef(null)
    const dRef = useRef(null)
    const sRef = useRef(null)
    const gRef = useRef(null)
    const yRef = useRef(null)

    //seed_varieties handler
    const varietiesHandler = (e) =>{
        setSV(e.target.value)
    }

    useEffect(()=>{
       // console.log(seed_varieties)
    }, [seed_varieties])

    //seed_name handler
    const nameHandler = (e) =>{
        setSN(e.target.value)
    }


    //handler setting
    const yearHandler = (e) =>{
        const x = e.target.value
        setYear(x)
      }

    useEffect(()=>{
       // console.log(seed_name)
    }, [seed_name])

    //district handler
  const districtHandler =(e)=>{
    const selectedName = e.target.value;
    const selectedOption = districts.find(district => district.district === selectedName);
   // console.log(selectedOption)
    setDistrict(selectedName)
    setDistrictID(selectedOption.district_id)
  }

    useEffect(()=>{
       // console.log(district)
    }, [district])

    //specification handler
    const specHandler = (e) =>{
        setSpec(e.target.value)
    }

    useEffect(()=>{
       // console.log(specification)
    }, [specification])

    //Germination handler
    const germHandler = (e) =>{
        setGerm(e.target.value)
    }

    useEffect(()=>{
       // console.log(germination)
    }, [germination])

    //reset fields
    const reset=()=>{
        snRef.current.value=''
        svRef.current.value=''
        dRef.current.value=''
        sRef.current.value=''
        gRef.current.value=''
        yRef.current.value=''
        setSV(null)
        setSN(null)
        setSpec(null)
        setGerm(null)
        setDistrict(null)
        setYear(null)
    }

    const {_id} = useParams()
    const gerrit = async () =>{
        const token = sessionStorage.getItem('token')
        const response = await fetch(`${process.env.REACT_APP_API_URL}/getSowings/${_id}`,{
            headers: {
              'x-access-token': token
            }
          })
        const data = await response.json()
        setSV(data.seed_varieties)
        setSN(data.seed_name)
        setDistrict(data.district)
        setSpec(data.specification)
        setGerm(data.germination)
        setYear(data.year)
    }

    useEffect(()=>{
        gerrit()
    },[])

    const handleSubmit = async(e) =>{
        e.preventDefault()
        const token = sessionStorage.getItem('token')
        const sowing = {seed_varieties, seed_name, district, district_id, specification, germination, year}
        const response = await fetch(`${process.env.REACT_APP_API_URL}/updateSowing/${_id}`, {
            method:'PUT',
            headers:{
                'Content-Type':'application/json',
                'x-access-token':token
            },
            body:JSON.stringify(sowing)
            }
        )
        // .then(console.log("Successfully submitted"))
    }
  return (
   <>
    <div className="sidebar">
    <Sidebar/>
  </div>
    <div id='bydrop'> 

    <h1>Update Sowing</h1>

      <form onSubmit={handleSubmit} className='needs-validation'>

        
      <label htmlFor="num-value" className="form-label">Year</label>
      <div class="input-group mb-3">
      <select className="form-select" ref={yRef}  id="num-value" value={year} onChange={yearHandler} required aria-label="Select example">
                    <option value="">Select year</option>
                    <option value="2025-26">2025-26</option>
                          <option value="2024-25">2024-25</option>
                          <option value="2023-24">2023-24</option>
                          <option value="2022-23">2022-23</option>
                          <option value="2021-22">2021-22</option>
                          <option value="2020-21">2020-21</option>
                          <option value="2019-20">2019-20</option>
                          <option value="2018-19">2018-19</option>
                          <option value="2017-18">2017-18</option>
                          <option value="2016-17">2016-17</option>
                          <option value="2015-16">2015-16</option>
                          <option value="2014-15">2014-15</option>
                          <option value="2013-14">2013-14</option>
                          <option value="2012-13">2012-13</option>
                          <option value="2011-12">2011-12</option>
                          <option value="2010-11">2010-11</option>
                    </select>       
                    </div>
    
      <label htmlFor="num-value" className="form-label">Seed Varieties</label>
      <div class="input-group mb-3">
        <input type="text" class="form-control" value={seed_varieties} ref={svRef} onChange={varietiesHandler} id='num-value' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" required/>
       </div>

       <label htmlFor="num-value" className="form-label">Seed Names</label>
      <div class="input-group mb-3">
        <input type="text" class="form-control" value={seed_name} ref={snRef} onChange={nameHandler} id='num-value' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" required/>
       </div>

        {/**Station */}
    <label htmlFor="inputGroupSelect07" className="form-label">District</label>
            <div className="input-group mb-3">
                <select className="form-select" value={district} ref={dRef} id="num-value" onChange={districtHandler} required aria-label="Select example">
                    <option value="">Select district</option>
                    {districts.map((district) => (
                        <option key={district.district_id} value={district.district}>
                            {district.district}
                        </option>
                    ))}
                </select>
            </div> 

       <div class="mb-3">
  <label for="exampleFormControlTextarea1" class="form-label">Specification</label>
  <textarea class="form-control" value={specification} ref={sRef} onChange={specHandler} maxLength={160} placeholder='Placeholder...' id="exampleFormControlTextarea1" rows="3"></textarea>
</div>
<p style={{color:"grey"}}>160 characters</p>

       <label htmlFor="num-value" className="form-label">Germination</label>
      <div class="input-group mb-3">
        {/* <input type="text" class="form-control" value={form.crop_condition} ref={cRef} onChange={cropConditionHandler} id='num-value' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" required/> */}
       <select className="form-select" value={germination} ref={gRef} onChange={germHandler} id='num-value'>
       <option>Select...</option>
    <option>Poor</option>
    <option>Fair</option>
    <option>Good</option>
    <option>Excellent</option>
  </select>
       </div>

       <button type="submit"  className="btn btn-secondary btn-lg">Submit</button>
      </form>
    </div>
   </>
  )
}
